export const setting= {
  name: "Usblick",
  production: true,
  c_domain: '.usblick.com',
  authApiUrl: 'https://fusionpax-api.fusionpax.com/api/',
  appUrl: 'https://usblick.com', /// temporal debe ir usblick.com
  appBookingBackoffice: 'https://booking-bo.usblick.com/',
  appBookingUrl: 'https://booking-app.usblick.com/',
  apiBookingUrl: 'https://booking-api.usblick.com/api/v1/',
  apiOctopusUrl: 'https://octopus-api.fusionpax.com/api',
  routeUploadFile: 'https://fusionpax-api.fusionpax.com/storage/',
  apiStorageBooking: 'https://booking-api.usblick.com/storage/',
  apiAbacoUrl: 'https://abaco-api.usblick.com/api/v1/',
  clientIdPaypal:"EHd6g3jaGD82NlUcn09stPzBNEgVYQaSUge13EY8wMcbnXHXS_gAkGuEATvJ9qsCjRMCffvwzFVDDEH6", 
  client_id:  'QA7kxgtk2eKrJDwK',
  client_secret: 'mL6SNux7pD8p8FoQRneYz0BP9NI9AP1519938479',
  defauldTimeBooking: 10,
  ApiUser : "MOEBIUS_TEST",
  ApiKey  : "MB25*SRTTS2",
  abacoApiUser: "devUser",
  abacoApiKey: "DevUs2024#?13579",
  // Square payment platform
  squareLocationId: "EAAAlwG8UJT4eXk6_nuRU2-Sldiop1ADOrNsolhwXIKDV2TctNLqlLUgPxvKvhSL",
  squareApplicationId: "sandbox-sq0idb-ihglSG6-anE9432sChG_lA",
  booking_api_user: "PRODBOOKINGAPP1113",
  booking_api_key: "829a7597128a5e177efffca73f480e5e76ed7690577a3fcc99127843d14c8c09",
  app_names: {
  	booking_backoffice: 'backoffice',
  	zoco: 'zoco',
  	booking: 'booking',
  	abaco: 'abaco',
  	chat: 'chat',
  	octopus: 'octopus'
  },
  ActivatedGuard: true
};
